import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
// Group-specific members
const GROUP_MEMBERS: Record<string, any[]> = {
  '1': [{
    name: 'Laura Bianchi',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    location: 'Milano',
    postsThisWeek: 12,
    isActive: true
  }, {
    name: 'Marco Rossi',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    location: 'Torino',
    postsThisWeek: 8,
    isActive: true
  }, {
    name: 'Giulia Neri',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    location: 'Roma',
    postsThisWeek: 6,
    isActive: true
  }, {
    name: 'Sara Conti',
    avatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    location: 'Bologna',
    postsThisWeek: 4,
    isActive: false
  }, {
    name: 'Greenback AI',
    avatar: 'https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png',
    location: 'Online',
    postsThisWeek: 15,
    isActive: true,
    isBot: true
  }],
  '2': [{
    name: 'Alessandro Verdi',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    location: 'Torino',
    postsThisWeek: 10,
    isActive: true
  }, {
    name: 'Chiara Riva',
    avatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    location: 'Milano',
    postsThisWeek: 7,
    isActive: true
  }, {
    name: 'Edoardo G.',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    location: 'Bologna',
    postsThisWeek: 5,
    isActive: true
  }, {
    name: 'Luca Ferri',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    location: 'Firenze',
    postsThisWeek: 3,
    isActive: false
  }, {
    name: 'Greenback AI',
    avatar: 'https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png',
    location: 'Online',
    postsThisWeek: 11,
    isActive: true,
    isBot: true
  }],
  '3': [{
    name: 'Sara Conti',
    avatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    location: 'Roma',
    postsThisWeek: 15,
    isActive: true
  }, {
    name: 'Luca Ferri',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    location: 'Milano',
    postsThisWeek: 9,
    isActive: true
  }, {
    name: 'Elena P.',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    location: 'Torino',
    postsThisWeek: 7,
    isActive: true
  }, {
    name: 'Marco Rossi',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    location: 'Bologna',
    postsThisWeek: 4,
    isActive: false
  }, {
    name: 'Greenback AI',
    avatar: 'https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png',
    location: 'Online',
    postsThisWeek: 18,
    isActive: true,
    isBot: true
  }]
};
const GroupMembers: React.FC<{
  groupId?: string;
}> = ({
  groupId
}) => {
  const members = GROUP_MEMBERS[groupId || '1'] || GROUP_MEMBERS['1'];
  return <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm" data-id="element-1788">
      <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1789">
        Membri ({members.length})
      </h2>
      <div className="space-y-3" data-id="element-1790">
        {members.map((member, index) => <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-1791">
            <div className="flex items-center gap-3 flex-1" data-id="element-1792">
              <div className={`w-10 h-10 rounded-full overflow-hidden flex-shrink-0 ${member.isBot ? 'bg-green-100 flex items-center justify-center' : ''}`} data-id="element-1793">
                {member.isBot ? <img src={member.avatar} alt={member.name} className="w-6 h-6 object-contain" data-id="element-1794" /> : <img src={member.avatar} alt={member.name} className="w-full h-full object-cover" data-id="element-1795" />}
              </div>
              <div className="flex-1 min-w-0" data-id="element-1796">
                <div className="flex items-center gap-2" data-id="element-1797">
                  <h3 className="font-medium text-gray-900 text-sm truncate" data-id="element-1798">
                    {member.name}
                  </h3>
                  {member.isBot && <span className="bg-green-100 text-green-700 text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap" data-id="element-1799">
                      AI
                    </span>}
                  {member.isActive && !member.isBot && <span className="bg-blue-100 text-blue-700 text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap" data-id="element-1800">
                      Attivo
                    </span>}
                </div>
                <p className="text-xs text-gray-500 font-normal mt-0.5" data-id="element-1801">
                  {member.location}
                </p>
              </div>
            </div>
            <div className="text-right ml-3" data-id="element-1802">
              <p className="text-xs text-gray-500 font-normal" data-id="element-1803">
                {member.postsThisWeek} post
              </p>
              <p className="text-xs text-gray-400 font-normal" data-id="element-1804">
                questa settimana
              </p>
            </div>
          </div>)}
      </div>
    </div>;
};
export default GroupMembers;